// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1VyHa","emails":"CreateEditClinics_emails__dbFtv","emailTagLabel":"CreateEditClinics_emailTagLabel__25vFr"};